import { ReactNode } from 'react'

type StatusProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'grey' | 'blue' | 'blue-stroke' | 'green-stroke' | 'blank'
  label: string | ReactNode
  iconName?: string
  loading?: boolean
}

const variantMap = {
  grey: {
    bg: 'bg-[#6C6C6C]',
    text: 'text-[#6C6C6C]',
    border: 'border-[#6C6C6C]',
  },
  blue: {
    bg: 'bg-[#2196F3]',
    text: 'text-[#2196F3]',
    border: 'border-[#1D4CA7]',
  },
  'blue-stroke': {
    bg: 'bg-[#2196F3]',
    text: 'text-[#2196F3]',
    border: 'border-[#1D4CA7]',
  },
  'green-stroke': {
    bg: 'bg-[#2E7D32]',
    text: 'text-[#2E7D32]',
    border: 'border-[#67C23A]',
  },
  'red-stroke': {
    bg: 'bg-[#FF0000]',
    text: 'text-[#FF0000]',
    border: 'border-[#FF0000]',
  },
  blank: {
    bg: '',
    text: '',
    border: '',
  },
}

export function Status(props: StatusProps) {
  const {
    type,
    label,
    variant = 'gold',
    loading = false,
    iconName,
    className,
    disabled,
    ...otherProps
  } = props
  return (
    <span
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line tailwindcss/no-custom-classname, tailwindcss/classnames-order
      className={`Type-Large-Bold inline-flex items-center justify-center uppercase ${
        variant === 'blank' ? '' : 'rounded-[5px]'
      } ${variantMap[variant].text} ${disabled ? 'text-50-grey' : ''} ${className}`}
      {...otherProps}
    >
      {/* {iconName && <Icon name={iconName} className='mr-[5px] align-middle text-xl' />} */}
      {label}
      {/* {loading ? <Icon name='hourglass_top' className='ml-[10px] inline-block align-middle' /> : ''} */}
    </span>
  )
}
